import React from 'react';
import { Button } from '../../../components/ui';
import { Loading } from '../Loading';
import { useDisconnectApollo } from '../hooks/useDisconnectApollo';

type Props = {
  tenant: number;
};
export function ConnectedView({ tenant }: Props) {
  const {
    mutate: disconnect,
    isLoading: isDisconnecting,
  } = useDisconnectApollo(tenant);

  if (isDisconnecting)
    return <Loading loadingLabel="Disconnecting from Apollo" />;

  return (
    <>
      <p>
        Status: <b className="tw-text-green-500">You're connected to Apollo</b>
      </p>

      <Button color="danger" onClick={() => disconnect()}>
        Disconnect
      </Button>
    </>
  );
}
